export default "__VITE_ASSET__B5r$VH6k__"